import { render, staticRenderFns } from "./MemberBanner.vue?vue&type=template&id=5d3589cc"
import script from "./MemberBanner.vue?vue&type=script&lang=js"
export * from "./MemberBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports